import { Button } from "../../../../core/components/atoms/Button";
import { Modal } from "../../../../core/components/templates/Modal";
import { useDisciplinesAuxStore } from "../../stores/auxStore";
import ExerciseContentFilter from "./Content/exercicios";
import AnotherContentFilter from "./Content/outros";

interface IFilterModal {
  modalName: string;
  type: string;
  title: string;
  reset: () => void;
  onSubmit: () => void;
}

export default function FilterModal({ reset, onSubmit, modalName, type, title }: IFilterModal) {
  const { openModal, setOpenModal } = useDisciplinesAuxStore();

  const handleSubmit = () => {
    setOpenModal(undefined);
    onSubmit();
  }
  
  return (
    <Modal
      title={title}
      position='top-right'
      size='md'
      isOpen={openModal === modalName}
      onClose={() => setOpenModal(undefined)}
      className='   
        m-0 
        mt-[10vh] 
        flex 
        min-h-[90vh]
        
        max-w-full 
        flex-col 
        rounded-b-none 
        md:m-4
        md:min-h-[calc(100%-2rem)]
    
        md:max-w-lg 
        md:rounded-b-lg'
    >
      <div className='flex w-full flex-col gap-md overflow-x-auto px-4 py-5 xs:h-[45vh] lg:h-[75vh]'>
        {type !== 'exercicio' && <AnotherContentFilter contentType={type} />}
        {type === 'exercicio' && <ExerciseContentFilter />}
      </div>
      <div className='fixed bottom-0 left-0 flex w-full flex-row items-center justify-center gap-lg px-4 py-5'>
        <Button
          variant='text'
          LeftIcon='delete'
          iconType='material'
          className='w-1/2'
          full
          onClick={() => reset()}
        >
          Limpar seleção
        </Button>
        <Button className='w-1/2' full onClick={() => handleSubmit()}>
          Aplicar filtros
        </Button>
      </div>
    </Modal>
  );
}
